export enum StockStatus {
    Status0 = 'status0',
    Status1 = 'status1',
    Status2 = 'status2',
    Status3 = 'status3',
    Status4 = 'status4',
}
